<template>
  <div class="navigation-bar">
    <b-navbar toggleable="lg" type="light" variant="light" class="px-3">
      <b-navbar-brand >
        <router-link :to="{name: 'home'}">
          <img alt="Vue logo" class="vuelogo" src="../assets/logo.png">
          </router-link>
      </b-navbar-brand>

      <b-navbar-nav class="position-absolute"
                    style="z-index: 5; margin-left: 50%; transform: translate(-50%); top: 15px">{{ navTitle }}
      </b-navbar-nav>
      <b-navbar-toggle v-if="connected" target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>

        <b-navbar-nav v-if="connected">
          <b-nav-item :to="{ name: 'categories' }">Saisie</b-nav-item>
          <b-nav-item :to="{name: 'liste'}" exact exact-active-class="active">Suivi</b-nav-item>
          <b-nav-item :to="{name: 'patrimoine'}" exact exact-active-class="active">Patrimoine</b-nav-item>
          <b-nav-item v-if="showRelance" :to="{name: 'relance'}" exact exact-active-class="active">Relance</b-nav-item>
          <b-nav-item v-if="showToute" :to="{name: 'all'}" exact exact-active-class="active">Toutes</b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav class="mx-auto">


            <b-nav-item class="mb-0 d-inline mx-2" href="/Manuel.pdf" right target="_blank"><i class="far fa-file-pdf"></i>
            </b-nav-item>
            <b-nav-item-dropdown v-if="connected" right>
              <!-- Using 'button-content' slot -->
              <template v-slot:button-content>
                <em>{{ nameUser }}</em>
              </template>
              <!--            <b-dropdown-item :to="{ name: 'login' }">Connexion</b-dropdown-item>-->
              <b-dropdown-item :to="{ name: 'profile' }"><i class="fas fa-user"></i> Profile</b-dropdown-item>
              <b-dropdown-item href="/"><i class="fa fa-refresh" aria-hidden="true"></i> Recharger</b-dropdown-item>
              <b-dropdown-item @click="handleLogout('Déconnexion en cours')"><i class="fas fa-sign-out-alt"></i> Déconnexion</b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-text>V{{ appVersion }}</b-dropdown-text>
            </b-nav-item-dropdown>
          </b-nav>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import AuthAPI from "../services/authAPI";
import toast from "../js/toast";
import { mapGetters, mapActions } from 'vuex';
import {version} from '../../package'
import userManager from '@amsom-habitat/user-manager'

export default {
  name: "Navbar",
  data() {
    return {
      appVersion:version
    }
  },
  methods: {
    ...mapActions('sollicitations', ['clearSollicitations']),
    async handleLogout(userInformation) {
      await AuthAPI.logout()
      this.clearSollicitations();
      if (this.$router.currentRoute.name != 'login'){
        toast.showToast('info', userInformation, 2000)
        userManager.goToLoginPage()
      }
    }
  },
  computed: {
    ...mapGetters('user', ['isValid', 'getPrenomNOM', 'getRoles', 'isAdmin']),
    ...mapGetters('title', ['getTitle']),
    connected() {
      return this.isValid
    },
    nameUser(){
      return this.getPrenomNOM
    },
    navTitle() {
      if (this.getTitle !== null && this.getTitle != "")
        return this.getTitle
      else
        return "Menu"
    },
    showRelance(){
      return this.getRoles.includes('ROLE_GESTIONNAIRE_RELANCE')
    },
    showToute(){
      return this.isAdmin;
    }

  },
  mounted() {
    document.title = "Suivi sollicitations"
  }
}
</script>

<style scoped>

.vuelogo {
  height: 20px;
}

</style>
